/**
 * Vega şemasının koyu/açık görünüm tercihi.
 *
 * Bu bir **tasarım ayarı değildir**: sitenin şeması panelden seçilir ve
 * bütün ziyaretçiler için aynıdır; buradaki tercih tek bir oyuncunun kendi
 * tarayıcısında geçerlidir ve `localStorage`'ta durur (Herkül'ün sohbet
 * rayı ve daraltılmış menü tercihiyle aynı yaklaşım).
 *
 * Renklerin kendisi CSS'tedir (`.vega-shell.is-light`, bkz. vega.css); bu
 * modülün tek işi tercihi okumak, yazmak ve kabuğun **dışında** kalan iki
 * yüzeye — `<body>` zeminine ve Android'in adres çubuğunu boyayan
 * `<meta name="theme-color">` etiketine — uygulamaktır. Kabuğun içi zaten
 * `.vega-shell` üzerinden boyanır.
 */

export const VEGA_MODE_KEY = 'vega:mode';
export const VEGA_MODE_ATTRIBUTE = 'data-vega-mode';

// Açık görünümün zemini; `.vega-shell.is-light` içindeki `--pusu-bg` ile
// **aynı kalmalıdır**. Ayrışırsa sayfanın altında (içerik bittiği yerde)
// ikinci bir renk şeridi görünür.
export const VEGA_LIGHT_BG = '#dddddd';

/** Kayıtlı görünüm tercihi; hiç seçilmemişse koyu. */
export const readVegaMode = () => {
  try {
    return window.localStorage.getItem(VEGA_MODE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    // Gizli sekmede ya da depolaması kapalı tarayıcıda şema yine çalışır.
    return 'dark';
  }
};

/**
 * Tercihi belgeye uygular ve saklar.
 *
 * `doc` yalnızca testler için parametredir; uygulamada her zaman gerçek
 * belge kullanılır.
 */
export const applyVegaMode = (
  mode,
  doc = typeof document !== 'undefined' ? document : null,
) => {
  const value = mode === 'light' ? 'light' : 'dark';
  if (!doc) return value;

  const root = doc.documentElement;
  if (value === 'light') {
    root.setAttribute(VEGA_MODE_ATTRIBUTE, 'light');
  } else {
    root.removeAttribute(VEGA_MODE_ATTRIBUTE);
  }

  try {
    // Kabuk söküldüğünde (başka bir şemaya geçiş, panele giriş) çağrı
    // "dark" ile gelir; o durumda tercihi **silmeyiz** — oyuncu portala
    // döndüğünde seçtiği görünümü bulmalıdır. Yazma yalnızca oyuncunun
    // anahtara bastığı anda anlamlıdır, bu yüzden kayıt ayrı tutulur.
  } catch {
    // yoksayılır
  }

  return value;
};

/** Tercihi kalıcı olarak yazar (anahtara basıldığında çağrılır). */
export const storeVegaMode = (mode) => {
  const value = mode === 'light' ? 'light' : 'dark';
  try {
    window.localStorage.setItem(VEGA_MODE_KEY, value);
  } catch {
    // Depolama kapalıysa tercih yalnızca bu sayfa ömrü boyunca yaşar.
  }
  return value;
};

export default applyVegaMode;
